import { render } from "./ChurchLifeCard.vue?vue&type=template&id=1656beef"
import script from "./ChurchLifeCard.vue?vue&type=script&lang=js"
export * from "./ChurchLifeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__